import {create} from "zustand";

type CatalogMenuStore = {
    opened: boolean;
    open: () => void;
    close: () => void;
    toggle: () => void;
};
export const useCatalogMenuStore = create<CatalogMenuStore>((set) => ({
    opened: false,
    open: () => set({opened: true}),
    close: () => set({opened: false}),
    toggle: () => set(state => ({opened: !state.opened})),
}));
